import { useCallback, useRef, useState } from 'react';

export function useReveal<T extends HTMLElement = HTMLDivElement>(threshold = 0.1) {
  const [revealed, setRevealed] = useState(false);
  const observerRef = useRef<IntersectionObserver | null>(null);
  const revealedRef = useRef(false);

  // Callback ref: called every time the element mounts/unmounts, even conditionally
  const ref = useCallback((el: T | null) => {
    if (observerRef.current) {
      observerRef.current.disconnect();
      observerRef.current = null;
    }
    if (!el || revealedRef.current) return;

    observerRef.current = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          revealedRef.current = true;
          setRevealed(true);
          observerRef.current?.disconnect();
          observerRef.current = null;
        }
      },
      { threshold, rootMargin: '0px 0px -40px 0px' }
    );
    observerRef.current.observe(el);
  }, [threshold]);

  return { ref, revealed };
}
